import { Box, Button, Divider, Typography } from "@mui/material"
import CustomDialog from "components/Dialogs/MasterDialog"
import { CommonTexts, organizationsTexts } from "locale/es"
import { useDispatch } from "react-redux"
import { useLocation, useNavigate } from "react-router-dom"
import { deleteOrganizationAction } from "redux/reducers/organizationsReducer"
import { AppColors } from "resources/AppColors"

function DeleteOrganizationDialog() {
  const { entityId } = useLocation().state

  const navigate = useNavigate()

  const dispatch = useDispatch()

  function handleOnConfirmDeleteOrganization() {
    dispatch(deleteOrganizationAction(entityId))
    handleShowExitModal()
  };

  function handleShowExitModal() {
    navigate('/organizaciones')
  }

  return (
    <CustomDialog
      title={organizationsTexts.DELETED_TITLE}
      show={true}
      handleShow={handleShowExitModal}
    >
      <Divider />
      <Box py={2} px={3} sx={{ minWidth: "50%" }}>
        <Typography variant="body">
          {organizationsTexts.DELETED_CONFIRM}
        </Typography>
      </Box>
      <Divider />
      <Box display="flex" justifyContent="flex-end" p={1}>
        <Button
          style={{ backgroundColor: AppColors.RED }}
          color="primary"
          variant="contained"
          onClick={handleOnConfirmDeleteOrganization}
          data-cy="submit-delete-message-button"
        >
          {CommonTexts.DELETE}
        </Button>
      </Box>
    </CustomDialog>
  )
}

export default DeleteOrganizationDialog
